<template>
  <div class="links-container">
    <div class="links cards">
      <entry-link
        v-for="link in links"
        :key="'entry-link-' + link.id"
        :link="link"
        @delete="deleteLink"
      />
      <div class="action-card">
        <button
          type="button"
          :disabled="isDisabled"
          class="add-link btn btn-secondary"
          @click.prevent="addLink"
        >
          {{ lang.get('entries.form.add-link') }}
        </button>
        <p v-if="fileLimitReached" class="file-limit-reached">
          <slot name="file-limit-reached-text" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import EntryLink from './EntryLink';

export default {
  inject: ['lang'],
  components: {
    EntryLink
  },
  props: {
    fileLimit: {
      type: Number,
      default: null
    },
    fileCount: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fileLimitReached() {
      return this.fileLimit && this.fileLimit <= this.fileCount;
    },
    isDisabled() {
      return (
        this.disabled || this.fileLimitReached || this.locks.lockedOnSubmission
      );
    },
    ...mapState('entryForm', ['links', 'locks'])
  },
  methods: {
    ...mapMutations('entryForm', ['addLink', 'deleteLink'])
  }
};
</script>

<style scoped>
.links {
  display: flex;
  flex-wrap: wrap;
}

.action-card {
  margin: 20px 0;
  align-self: flex-start;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.file-limit-reached {
  padding: 0 5px;
  color: #ccc;
}
</style>
